import { EPlacingType } from '../../../../redux/reducers';

export const SWITCHER_OPTIONS = [
  {
    value: EPlacingType.package,
    label: 'Из пакета',
  },
  {
    value: EPlacingType.balance,
    label: 'Со счёта',
  },
];
